/*
 * Room Cloud
 */
function factory({ window, document, thn }) {
    const engine = {};
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            const $ = window.jQuery;
            let aux;
            const langTxt = (document.querySelector('#cmb_lng') || {}).textContent; // Language selector
            const lang = {
                Español: 'es',
                English: 'en',
                Français: 'fr',
                Deutsch: 'de',
                Italiano: 'it',
                Nederlands: 'nl',
            };
            aux = lang[langTxt];
            if (aux && ctx.langs.test(aux)) {
                resolve(aux);
                return;
            }
            aux = thn.parseUrlParameter('lang');
            if (aux && ctx.langs.test(aux)) {
                resolve(aux);
                return;
            }
            if ($) {
                aux = $("input[name='lang']").val();
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
            }
            aux = document.documentElement.lang;
            if (aux && ctx.langs.test(aux)) {
                resolve(aux);
                return;
            }
            reject('no_language');
        });
    };
    /**
     * @memberOf module:bs_88
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
    engine.generateSearchUrl = function generateSearchUrl(ctx) {
        // https://booking.roomcloud.net/be/se2/hotel.jsp?hotel=16901
        const url = new URL(ctx.baseUrl);
        const validUrl = url.hostname.match(/booking/);
        if (!validUrl) {
            ctx.newUrl = '';
            return ctx;
        }
        ctx.newUrl = url.toString();
        return ctx;
    };
    /**
       * @memberOf module:bs_88
       * @see {@link onStateChange}
       *
       * @param {object} ctx - The context object.
       */
    engine.onStateChange = function onStateChange(ctx) {
        if (window.location.hostname.match(/^apartur.com.ar/)) {
            thn.pageCheck();
        }
    };
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        const $ = window.jQuery;
        // For hotels that have different selectors from below (Ex. Apartur).
        let dateBegin = window.initial_checkin?.replaceAll('-', '/');
        let dateEnd = window.initial_checkout?.replaceAll('-', '/');
        if (dateBegin === undefined || dateEnd === undefined) {
            dateBegin = [$('input[name=start_year]').val(), $('input[name=start_month]').val(), $('input[name=start_day]').val()].join('/');
            dateEnd = [$('input[name=end_year]').val(), $('input[name=end_month]').val(), $('input[name=end_day]').val()].join('/');
        }
        const rates = [...document.querySelectorAll('.best-price-span .price_format')].map((el) => thn.parseNumber(el.textContent));
        // For other hotels the previous selectors won't work.
        widgetData.adults = parseInt($('input[name=adults]').val(), 10) || 1;
        widgetData.children = parseInt($('input[name=children]').val(), 10) || 0;
        widgetData.guests = widgetData.adults + widgetData.children;
        widgetData.rooms = 1;
        const currency = ((document.querySelector('.offer') || {}).textContent || '').split(' ')[1] || document.querySelector('#currencyMenu, #currencyMenu_mobile')?.textContent;
        widgetData.currency = $('#cmb_curr').text() || thn.parseUrlParameter('curr') || thn.parseCurrency(currency) || 'USD';
        const prices = $('span[id^=room_price_], div[id^=room_price_]').map(function (idx, el) {
            const $el = $(el), $offer = $('.room_offer', $el);
            return $offer.length
                ? thn.parseNumber($offer.text())
                : thn.parseNumber($el.text());
        }).toArray();
        widgetData.dateBegin = dateBegin;
        widgetData.dateEnd = dateEnd;
        if (prices.length !== 0) {
            widgetData.price = Math.min(...prices);
            widgetData.set = true;
        }
        else if (rates.length) {
            widgetData.price = Math.min(...rates);
            widgetData.set = true;
        }
        else {
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const $ = window.jQuery;
        widgetData.dateBegin = ($('#rc_checkin').val() || window.rc_checkin)?.replace(/-/g, '/');
        widgetData.dateEnd = ($('#rc_checkout').val() || window.rc_checkout)?.replace(/-/g, '/');
        widgetData.price = thn.parseNumber($('#totalTaxed').text() || window.rc_total)
            || parseFloat($('#rc_total').val()) || undefined;
        widgetData.currency = $('#cmb_curr').text() || $('#rc_currency').val() || window.rc_currency;
        widgetData.bookingId = $('#rc_id').val() || window.rc_id;
        return widgetData;
    };
    return engine;
}

export { factory };
